import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import {Link} from 'react-router-dom';
import urlHandler from '../../utils/urlHandler';

import DocOverview from './pages/docOverView';
import DocV2Entities                        from './pages/docV2Entities';
import DocV2EntitiesCreate                  from './pages/docV2EntitiesCreate';
import DocV2EntitiesDelete                  from './pages/docV2EntitiesDelete';
import DocV2EntitiesUpdate                  from './pages/docV2EntitiesUpdate';
import DocV1Sentiment                       from './pages/docV1Sentiment';
import DocKbAttributes                      from './pages/docKbAttributes';
import DocGeoEntity                         from './pages/docGeoEntity';
import DocOrganizationEntity                from './pages/docOrganizationEntity';
import DocThingEntity                       from './pages/docThingEntity';
import DocPersonEntity                      from './pages/docPersonEntity';
import DocDateTimeEntity                    from './pages/docDateTimeEntity';
import DocDateTimeRangeEntity               from './pages/docDateTimeRangeEntity';
import DocEmailEntity                       from './pages/docEmailEntity';
import DocIpv4Entity                        from './pages/docIpv4Entity';
import DocCyberEntity                       from './pages/docCyberEntity';
import DocMeasurementEntity                 from './pages/docMeasurementEntity';
import DocPaymentEntity                     from './pages/docPaymentEntity';
import DocMoneyEntity                       from './pages/docMoneyEntity';
import DocNationalityEntity                 from './pages/docNationalityEntity';
import DocLanguageEntity                 from './pages/docLanguageEntity';
import DocPhoneEntity                       from './pages/docPhoneEntity';
import DocPositionEntity                    from './pages/docPositionEntity';
import DocTwitterEntity                     from './pages/docTwitterEntity';
import DocUriEntity                         from './pages/docUriEntity';
import DocAcronymEntity                     from './pages/docAcronymEntity';
import DocV2Enrich                          from './pages/docV2Enrich';
import DocV1QueryParser                     from './pages/docV1QueryParser';
import DocV1LocationFinder                  from './pages/docV1LocationFinder';
import DocV1InformationExtractionPrompts    from './pages/docV1InformationExtractionPrompts';
import DocV1ExtractionCreate                from './pages/docV1ExtractionCreate';
import DocV1ExtractionDelete                from './pages/docV1ExtractionDelete';
import DocV1ExtractionDeleteAll             from './pages/docV1ExtractionDeleteAll';
import DocV1ExtractionRetrieve              from './pages/docV1ExtractionRetrieve';
import DocV1ExtractionValidate              from './pages/docV1ExtractionValidate';
import DocCustomEntities                    from './pages/docCustomEntities';

import DocV1RegexCreate                     from './pages/docV1RegexCreate';
import DocV1RegexDelete                     from './pages/docV1RegexDelete';
import DocV1RegexDeleteAll                  from './pages/docV1RegexDeleteAll';
import DocV1RegexRetrieve                   from './pages/docV1RegexRetrieve';
import DocV1RegexValidate                   from './pages/docV1RegexValidate';
import DocCustomRegex                       from './pages/docCustomRegex';

import DocV1UserInfo                        from './pages/docV1UserInfo';
import DocPostman                           from './pages/docPostman';
import DocV1CorrectText                     from './pages/docV1CorrectText';
import DocV2DetectLanguage                  from './pages/docV2DetectLanguage';
import DocV2DetectLanguages                 from './pages/docV2DetectLanguages';
import DocV1Translate                       from './pages/docV1Translate';
import DocV1Summarize                       from './pages/docV1Summarize';
import DocV2Tag                             from './pages/docV2Tag';  
// import DocV1ConvertDoc                      from './pages/docV1ConvertDoc';
import DocV2ConvertDoc                      from './pages/docV2ConvertDoc';
import DocV1Usage                           from './pages/docV1Usage';
import DocV1Version                         from './pages/docV1Version';
import DocV1ExtractArticle                  from './pages/docV1ExtractArticle';
import DocV1AdminHealth                     from './pages/docV1AdminHealth';
import DocV1AdminSysInfo                    from './pages/docV1AdminSysInfo';
import DocV1AdminRestart                    from './pages/docV1AdminRestart';

class apiDoc extends Component {
    constructor(props){
        super(props);

        this.showAcctDialog = this.showAcctDialog.bind(this);
        this.showSupportDialog = this.showSupportDialog.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
    }

    showAcctDialog() {
        this.refs.acctdlg.open();
    }

    showSupportDialog() {
        this.refs.supportdlg.open();
    }

    scrollTo(anchor) {
        document.getElementById(anchor).scrollIntoView({block: 'start', behavior: 'smooth'});
    }

    render() {
        return (
            <div className="documentation-wrapper">
                <div className="doc-toc">
                    <h2 className="header">Table of Contents</h2>
                        <ul className="toc-level list-wrapper">
                            <li className="list-item">
                                <span className="static-list-link"><Link to="/documentation/doc_overview#top" className="list-link">Rest API Overview</Link></span>
                                <ul className="toc-level list-wrapper">
                                    {/* <li className="list-item">
                                        <Link to="/documentation/doc_overview#top" className="list-link">Overview</Link>
                                    </li> */}
                                    <li className="list-item">
                                        <Link to="/documentation/doc_overview#auth" className="list-link">Authentication</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_overview#error" className="list-link">Error Handling</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_overview#rate-limits" className="list-link">Rate Limits</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_postman#top" className="list-link">Postman Setup</Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="list-item list-section">
                                <span className="static-list-link">Admin Services</span>
                                <ul className="toc-level list-wrapper">
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1adminhealth#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_ADMIN_HEALTH}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1adminsysinfo#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_ADMIN_SYSINFO}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1adminrestart#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_ADMIN_RESTART}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1version#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_VERSION}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="list-item list-section">
                                <span className="static-list-link">Enrichment Services</span>
                                <ul className="toc-level list-wrapper">
                                    {/* <li className="list-item">
                                        <Link to="/documentation/doc_v1convertdoc" className="list-link">
                                            <span className="put-badge-small">PUT</span>  {urlHandler.API_ENDPOINT_V1_CONVERT_DOC}
                                        </Link>
                                    </li> */}
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2convertdoc#top" className="list-link">
                                            <span className="put-badge-small">PUT</span>  {urlHandler.API_ENDPOINT_V2_CONVERT_DOC}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1correcttext#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V1_CORRECT_TEXT}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1sentiment#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V1_DOC_SENTIMENT}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2enrich#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V2_ENRICH}
                                        </Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#top" className="list-link">Request</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_entity_types" className="list-link">Request Types & Models</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_response" className="list-link">Response</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_entity_object" className="list-link">Response Entities</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_mention_object" className="list-link">Response Mention</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_disambiguation_object" className="list-link">Response Disambiguation</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_sentiment_object" className="list-link">Response Sentiment</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_salience_object" className="list-link">Response Salience</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_industries_object" className="list-link">Response Industries</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_relationship_object" className="list-link">Response Relationships</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_v2enrich#enrichv2_tagmodel_object" className="list-link">Response Tags</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1queryparser#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_QUERY_PARSER}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1summarize#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V1_SUMMARIZE}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2tag#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V2_TAG}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1extractarticle#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_EXTRACT_ARTICLE}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="list-item list-section">
                                <span className="static-list-link">Entity Services</span>
                                <ul className="toc-level list-wrapper">

                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2entities#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V2_ENTITIES}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2entitiescreate#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V2_ENTITIES}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2entitiesupdate#top" className="list-link">
                                            <span className="put-badge-small">PUT</span>  {urlHandler.API_ENDPOINT_V2_ENTITIES}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2entitiesdelete#top" className="list-link">
                                            <span className="delete-badge-small">DELETE</span>  {urlHandler.API_ENDPOINT_V2_ENTITIES}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1locationfinder#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_LOCATION_FINDER}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1informationExtractionPrompts#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_INFORMATION_EXTRACTION_PROMPTS}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1extractioncreate#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V1_EXTRACTION_INSERT}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1extractionvalidate#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V1_EXTRACTION_VALIDATE}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1extractiondelete#top" className="list-link">
                                            <span className="delete-badge-small">DELETE</span>  {urlHandler.API_ENDPOINT_V1_EXTRACTION_DELETE}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1extractiondeleteall#top" className="list-link">
                                            <span className="delete-badge-small">DELETE</span>  {urlHandler.API_ENDPOINT_V1_EXTRACTION_DELETE_ALL}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1extractionretrieve#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_EXTRACTION_RETRIEVE}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1regexcreate#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V1_REGEX_INSERT}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1regexvalidate#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V1_REGEX_VALIDATE}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1regexdelete#top" className="list-link">
                                            <span className="delete-badge-small">DELETE</span>  {urlHandler.API_ENDPOINT_V1_REGEX_DELETE}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1regexdeleteall#top" className="list-link">
                                            <span className="delete-badge-small">DELETE</span>  {urlHandler.API_ENDPOINT_V1_REGEX_DELETE_ALL}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1regexretrieve#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_REGEX_RETRIEVE}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="list-item list-section">
                                <span className="static-list-link">User Services</span>
                                <ul className="toc-level list-wrapper">
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1userinfo#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_USERINFO}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1usage#top" className="list-link">
                                            <span className="get-badge-small">GET</span>  {urlHandler.API_ENDPOINT_V1_USAGE}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="list-item list-section">
                                <span className="static-list-link">Translation Services</span>
                                <ul className="toc-level list-wrapper">
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2detectlanguage#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V2_DETECT_LANGUAGE}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v2detectlanguages#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V2_DETECT_LANGUAGES}
                                        </Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_v1translate#top" className="list-link">
                                            <span className="post-badge-small">POST</span>  {urlHandler.API_ENDPOINT_V1_TRANSLATE}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="list-item list-section">
                                <span className="static-list-link">Entity Types</span>
                                <ul className="toc-level list-wrapper">
                                    <li className="list-item">
                                        <Link to="/documentation/doc_acronym#top" className="list-link">ACRONYM</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_cyber#top" className="list-link">CYBER/CVE</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_datetime#top" className="list-link">DATETIME</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_datetimerange#top" className="list-link">DATETIME_RANGE</Link>
                                    </li>                        
                                    <li className="list-item">
                                        <Link to="/documentation/doc_email#top" className="list-link">EMAIL</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_geo#top" className="list-link">GEO</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_ipv4#top" className="list-link">IPV4</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_language#top" className="list-link">LANGUAGE</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_measurement#top" className="list-link">MEASUREMENT</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_money#top" className="list-link">MONEY</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_nationality#top" className="list-link">NATIONALITY</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_organization#top" className="list-link">ORGANIZATION</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_company" className="list-link">ORGANIZATION/COMPANY</Link>
                                    </li>
                                    <li className="list-item sub-list-item">                                       
                                        <Link to="/documentation/doc_organization#stockticker" className="list-link">ORGANIZATION/COMPANY/TICKER</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_criminal" className="list-link">ORGANIZATION/CRIMINAL</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_educational" className="list-link">ORGANIZATION/EDUCATIONAL</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_fund" className="list-link">ORGANIZATION/FUND</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_government" className="list-link">ORGANIZATION/GOVERNMENT</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_news" className="list-link">ORGANIZATION/NEWS</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_performing" className="list-link">ORGANIZATION/PERFORMING</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_socialmedia" className="list-link">ORGANIZATION/SOCIALMEDIA</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_sports" className="list-link">ORGANIZATION/SPORTS</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_organization#sub_trust" className="list-link">ORGANIZATION/TRUST</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_payment#top" className="list-link">PAYMENT_CARD</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_person#top" className="list-link">PERSON</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_phone#top" className="list-link">PHONE</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_position#top" className="list-link">POSITION</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_thing#top" className="list-link">THING</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_chemical" className="list-link">THING/CHEMICAL</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_event" className="list-link">THING/EVENT</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_facility" className="list-link">THING/FACILITY</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_financial" className="list-link">THING/FINANCIAL</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_legal" className="list-link">THING/LEGAL</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_medical" className="list-link">THING/MEDICAL</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_product" className="list-link">THING/PRODUCT</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_program" className="list-link">THING/PROGRAM</Link>
                                    </li>
                                    <li className="list-item sub-list-item">
                                        <Link to="/documentation/doc_thing#sub_technology" className="list-link">THING/TECHNOLOGY</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_twitter#top" className="list-link">TWITTER</Link>
                                    </li>
                                    <li className="list-item">
                                        <Link to="/documentation/doc_uri#top" className="list-link">URI</Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="list-item">
                                <Link to="/documentation/doc_kbattributes#top" className="list-link">Knowledgebase Entities</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/documentation/doc_customentity#top" className="list-link">Custom Entities</Link>
                            </li>
                            <li className="list-item">
                                <Link to="/documentation/doc_customregex#top" className="list-link">Custom RegEx</Link>
                            </li>
                        </ul>  
                </div>
                <div className="doc-content">
                    <div id="doc-top"></div>
                    <Switch>
                        <Route path="/documentation/doc_overview" component={DocOverview}/>
                        <Route path="/documentation/doc_v1version" component={DocV1Version}/>
                        <Route path="/documentation/doc_v2entities" component={DocV2Entities}/>
                        <Route path="/documentation/doc_v2entitiescreate" component={DocV2EntitiesCreate}/>
                        <Route path="/documentation/doc_v2entitiesdelete" component={DocV2EntitiesDelete}/>
                        <Route path="/documentation/doc_v2entitiesupdate" component={DocV2EntitiesUpdate}/>
                        <Route path="/documentation/doc_v2enrich" component={DocV2Enrich}/>
                        <Route path="/documentation/doc_v1sentiment" component={DocV1Sentiment}/>
                        <Route path="/documentation/doc_v1queryparser" component={DocV1QueryParser}/>
                        <Route path="/documentation/doc_v1locationfinder" component={DocV1LocationFinder}/>
                        <Route path="/documentation/doc_v1informationExtractionPrompts" component={DocV1InformationExtractionPrompts}/>
                        <Route path="/documentation/doc_v1extractioncreate" component={DocV1ExtractionCreate}/>
                        <Route path="/documentation/doc_v1extractionvalidate" component={DocV1ExtractionValidate}/>
                        <Route path="/documentation/doc_v1extractiondelete" component={DocV1ExtractionDelete}/>
                        <Route path="/documentation/doc_v1extractiondeleteall" component={DocV1ExtractionDeleteAll}/>
                        <Route path="/documentation/doc_v1extractionretrieve" component={DocV1ExtractionRetrieve}/>
                        <Route path="/documentation/doc_v1regexcreate" component={DocV1RegexCreate}/>
                        <Route path="/documentation/doc_v1regexvalidate" component={DocV1RegexValidate}/>
                        <Route path="/documentation/doc_v1regexdelete" component={DocV1RegexDelete}/>
                        <Route path="/documentation/doc_v1regexdeleteall" component={DocV1RegexDeleteAll}/>
                        <Route path="/documentation/doc_v1regexretrieve" component={DocV1RegexRetrieve}/>
                        <Route path="/documentation/doc_customentity" component={DocCustomEntities}/>
                        <Route path="/documentation/doc_customregex" component={DocCustomRegex}/>
                        <Route path="/documentation/doc_v1userinfo" component={DocV1UserInfo}/>
                        <Route path="/documentation/doc_v1correcttext" component={DocV1CorrectText}/>
                        <Route path="/documentation/doc_v2detectlanguage" component={DocV2DetectLanguage}/>
                        <Route path="/documentation/doc_v2detectlanguages" component={DocV2DetectLanguages}/>
                        <Route path="/documentation/doc_v1translate" component={DocV1Translate}/>
                        <Route path="/documentation/doc_v1summarize" component={DocV1Summarize}/>
                        <Route path="/documentation/doc_v2tag" component={DocV2Tag}/>
                        {/* <Route path="/documentation/doc_v1convertdoc" component={DocV1ConvertDoc}/> */}
                        <Route path="/documentation/doc_v2convertdoc" component={DocV2ConvertDoc}/>
                        <Route path="/documentation/doc_v1extractarticle" component={DocV1ExtractArticle}/>
                        <Route path="/documentation/doc_v1usage" component={DocV1Usage}/>
                        <Route path="/documentation/doc_kbattributes" component={DocKbAttributes}/>
                        <Route path="/documentation/doc_acronym" component={DocAcronymEntity}/>
                        <Route path="/documentation/doc_geo" component={DocGeoEntity}/>
                        <Route path="/documentation/doc_organization" component={DocOrganizationEntity}/>
                        <Route path="/documentation/doc_thing" component={DocThingEntity}/>
                        <Route path="/documentation/doc_person" component={DocPersonEntity}/>
                        <Route path="/documentation/doc_datetime" component={DocDateTimeEntity}/>
                        <Route path="/documentation/doc_datetimerange" component={DocDateTimeRangeEntity}/>
                        <Route path="/documentation/doc_email" component={DocEmailEntity}/>
                        <Route path="/documentation/doc_ipv4" component={DocIpv4Entity}/>
                        <Route path="/documentation/doc_cyber" component={DocCyberEntity}/>
                        <Route path="/documentation/doc_measurement" component={DocMeasurementEntity}/>
                        <Route path="/documentation/doc_money" component={DocMoneyEntity}/>
                        <Route path="/documentation/doc_payment" component={DocPaymentEntity}/>
                        <Route path="/documentation/doc_nationality" component={DocNationalityEntity}/>
                        <Route path="/documentation/doc_language" component={DocLanguageEntity}/>
                        <Route path="/documentation/doc_phone" component={DocPhoneEntity}/>
                        <Route path="/documentation/doc_position" component={DocPositionEntity}/>
                        <Route path="/documentation/doc_twitter" component={DocTwitterEntity}/>
                        <Route path="/documentation/doc_uri" component={DocUriEntity}/>
                        <Route path="/documentation/doc_postman" component={DocPostman}/>

                        <Route path="/documentation/doc_v1adminhealth" component={DocV1AdminHealth}/>
                        <Route path="/documentation/doc_v1adminsysinfo" component={DocV1AdminSysInfo}/>
                        <Route path="/documentation/doc_v1adminrestart" component={DocV1AdminRestart}/>

                        <Route path="/documentation#top" component={DocOverview}/>
                    </Switch>
                    <span className="fa fa-arrow-circle-o-up scroll-up" onClick={() => {this.scrollTo('doc-top')}}></span>
                </div>
            </div>
        );
    }
}

export default apiDoc;